/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Travel_Start_Eta_HelpInputs */

const en_travel_start_eta_help = /** @type {(inputs: Travel_Start_Eta_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you expect to be on site.`)
};

const ja_travel_start_eta_help = /** @type {(inputs: Travel_Start_Eta_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現地到着の予定時刻です。`)
};

const fr_travel_start_eta_help = /** @type {(inputs: Travel_Start_Eta_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure prévue de votre arrivée sur site.`)
};

const de_travel_start_eta_help = /** @type {(inputs: Travel_Start_Eta_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann Sie voraussichtlich vor Ort sind.`)
};

/**
* | output |
* | --- |
* | "When you expect to be on site." |
*
* @param {Travel_Start_Eta_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const travel_start_eta_help = /** @type {((inputs?: Travel_Start_Eta_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Travel_Start_Eta_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_travel_start_eta_help(inputs)
	if (locale === "ja") return ja_travel_start_eta_help(inputs)
	if (locale === "fr") return fr_travel_start_eta_help(inputs)
	return de_travel_start_eta_help(inputs)
});